// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"hotspot-wave"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9 3H5V23H19V13","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M13 1C17.4183 1 21 4.58172 21 9M13 5C15.2091 5 17 6.79086 17 9M13 9H13.0039V9.00391H13V9Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-hotspot-wave')
export default class HotspotWaveIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'hotspot-wave',
    }
  }
}
